import React, { Component } from "react";
import Popup from "./Popup";
import Strings from "@my-dld/assets/strings";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

interface Props {
	title?: string;
	message: string;
}

class InfoPopup extends Component<Props> {
	render() {
		let { title, message } = this.props;
		if ( isEmptyStringOrNull( title ) ) {
			title = Strings.my_dld;
		}
		return <Popup
			id={ "InfoPopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered" }
			modalBodyContainer={ "modal-body" }
			title={ title }
			showIcon={ false }>
			<p style={ { whiteSpace: "pre-wrap" } }>
				{ message }
			</p>
		</Popup>;
	}
}

export default InfoPopup;
